import { StreamdownLite } from '../../../../web/components-v2/ai/StreamdownLite';

// Cards and the Game Plan are model output fed with lead records and the AI prospect's words, so nothing in them may load a
// remote image or link off the page.
export const CardMarkdown = ({ children }: { children: string }) => (
	<StreamdownLite allowedImagePrefixes={[]} allowedLinkPrefixes={[]}>
		{children}
	</StreamdownLite>
);
